import React, { Fragment, memo } from 'react'
// Project File Imports
import MenuContent from './MenuContent'
// Material UI Imports
import { SwipeableDrawer, Paper, Box } from '@mui/material/'
import { useTheme } from '@mui/material/styles'

const Menu = (props) => {
  const {
    hasAuth,
    swapMenuWidth,
    avatarMenuItems,
    authService,
    onClose,
    width,
    swapMenu,
    menuItems,
    isOpen,
    onOpen,
    logos,
  } = props
  const drawer = (
    <MenuContent
      hasAuth={hasAuth}
      authService={authService}
      swapMenuWidth={swapMenuWidth}
      avatarMenuItems={avatarMenuItems}
      menuItems={menuItems}
      onClose={onClose}
      swapMenu={swapMenu}
      logos={logos}      
    />
  )
  const theme = useTheme()
  const drawerPaperStyle = {
    position: 'relative',
    zIndex:900000,
    whiteSpace: 'nowrap',        
    border: 'none',  
    overflow: 'hidden',    
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
  }
  return (
    <Fragment>
      <Box sx={{display:{lg:"none"}}}>
        <SwipeableDrawer                 
          variant='temporary'
          style={{ maxWidth: "90%",boxShadow: theme.shadows[4],}}
          open={isOpen ? true : false}
          onClose={onClose}
          onOpen={onOpen}
          PaperProps={{            
            style: drawerPaperStyle
          }}         
        > 
          {drawer}         
        </SwipeableDrawer>
      </Box>
      <Box sx={{display:{xs:"none",md:"block"}}}>
        <Paper
          style={{                        
            height:'100%',            
            boxShadow: theme.shadows[4],
            width: width,
            zIndex:theme.zIndex.drawer,
            transition: theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            })
          }}
        >          
          {drawer}
        </Paper>
      </Box>
    </Fragment>
  )
}

export default memo(Menu)
